// extracted by mini-css-extract-plugin
module.exports = {"item":"newLayer_item__2w86y","itemBtn":"newLayer_itemBtn__1yua5"};